/** Canadian Beef design tokens — single source for Insights pricing design work. */
export const brandRed = "#960B10";
export const redDeep = "#6B0509";
export const redDark = "#4A0306";
export const paper = "#FFFFFF";
export const bone = "#F1ECE2";
export const stone = "#E6E1D9";
export const ink = "#111111";
export const smoke = "#3A3A3A";
export const soot = "#222222";
export const cardShadow = "6px 6px 0 rgba(0, 0, 0, 0.28)";
export const cardRadius = "12px";

/** DS pattern ground / splash band — Bone until a literal pattern asset exists. */
export const patternGround = bone;

/** Single colour for single-dataset bar charts (snapshot, quarterly, flyer province). */
export const insightsBarChartColor = brandRed;
export const insightsSnapshotBarColor = insightsBarChartColor;
